<template>
    <BaseChip
        class="gst-campaign-status-chip"
        :class="{
            'gst-campaign-status-chip--active': isActive,
            'gst-campaign-status-chip--inactive': !isActive,
        }">
        <span class="gst-campaign-status-chip__content">{{ label }}</span>
    </BaseChip>
</template>

<script>
import BaseChip from './BaseChip.vue';

export default {
    name: 'CampaignStatusChip',
    components: {
        BaseChip,
    },
    props: {
        params: {
            type: Object,
            required: true,
        },
    },
    computed: {
        isActive() {
            return this.params.value === true;
        },
        label() {
            return this.isActive
                ? this.$t('_common:terms.statusActive')
                : this.$t('_common:terms.statusInactive');
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@scssVariables';

.gst-campaign-status-chip {
    border-radius: 4px;

    .gst-campaign-status-chip__content::before {
        margin-right: theme-spacing(2);
        font: bold 1.5em/0 monospace;
        line-height: 1.1;
        vertical-align: middle;
        content: '\2022';
    }
}

.gst-campaign-status-chip--active {
    background-color: rgba(theme-color-hex('statusSuccess'), 0.2) !important;

    .gst-campaign-status-chip__content::before {
        color: theme-color('statusSuccess');
    }
}

.gst-campaign-status-chip--inactive {
    background-color: rgba(theme-color-hex('septenary'), 0.1);
    color: theme-color('septenary');

    .gst-campaign-status-chip__content::before {
        color: theme-color('septenary');
    }
}
</style>
